import React from 'react';

const PartnersSection = () => {
  const partners = [
    { 
      name: 'Hettich', 
      description: 'Precision German engineering'
    },
    { 
      name: 'Blum', 
      description: 'Advanced motion technology'
    },
    { 
      name: 'HiGold', 
      description: 'Premium kitchen accessories'
    },
    { 
      name: 'Rehau', 
      description: 'Innovative surface solutions'
    },
    { 
      name: 'Kessebohmer', 
      description: 'Intelligent storage systems'
    },
    { 
      name: 'Hafele', 
      description: 'Global furniture fittings leader'
    }
  ];

  return (
    <section className="py-20 lg:py-32 bg-white scroll-animate">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl text-[#111111] mb-4">
            Our Trusted Partners
          </h2>
          <p className="text-[#242424] max-w-2xl mx-auto leading-relaxed">
            Collaborating with industry-leading global brands
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {partners.map((partner) => (
            <div
              key={partner.name}
              className="partner-card group relative flex flex-col items-center justify-center p-8 md:p-10 bg-white border border-[#111111]/10 rounded-luxury hover:border-[#B89A4F] hover:shadow-luxury transition-all duration-300"
            >
              <h3 className="font-serif text-2xl md:text-3xl font-semibold text-[#111111] mb-2 tracking-wide group-hover:text-[#B89A4F] transition-colors duration-300">
                {partner.name}
              </h3>
              <p className="text-xs text-[#242424]/70 text-center leading-relaxed">
                {partner.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
